import { Box, Typography } from '@mui/material'
import { useStep } from '../hooks/useStep'
import { COLORS } from '../theme'
import { stepHeadingSx, stepDescriptionSx } from '../styles'

export default function IntroVideo() {
  useStep({})

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Box sx={{ width: '100%', maxWidth: 600 }}>
        <Typography
          variant="h5"
          sx={{ ...stepHeadingSx, mb: 1, textAlign: 'center' }}
        >
          Welcome to Fundsorter!
        </Typography>

        <Typography sx={{ ...stepDescriptionSx, textAlign: 'center', mb: 2 }}>
          Hi, I'm Lani, one of the creators of Fundsorter. Watch this video to
          spend a few minutes with me learning how it all works.
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          maxWidth: 600,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 2,
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          mb: 2,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: '56.25%', // 16:9 aspect ratio
          }}
        >
          <video
            controls
            title="Welcome to Fundsorter"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          >
            <source
              src={import.meta.env.VITE_ONBOARDING_VIDEO_URL}
              type="video/mp4"
            />
          </video>
        </Box>
      </Box>

      <Typography
        sx={{ ...stepDescriptionSx, textAlign: 'center', maxWidth: 520, mb: 0 }}
      >
        I'll guide you through setting up your organisation profile, uploading
        key documents, and finding funding opportunities that match your needs.
      </Typography>
    </Box>
  )
}
